module.exports = __webpack_public_path__ + "static/img/th-crva-factsheet.e93da61.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbnails/th-crva-factsheet.png
// module id = Uw7j
// module chunks = 1